import type { ScanMode } from '../../pages/pick-pack-station/main/modes';
import { SCAN_MODES } from '../../pages/pick-pack-station/main/modes';

export const selectActiveMode = (state: { activeMode?: ScanMode | null }): ScanMode => state?.activeMode ?? SCAN_MODES.verifyAndPrint;

export const selectFulfillmentPlanId = (state: { fulfillmentPlanId?: string | null }): string | null => state?.fulfillmentPlanId ?? null;

export const selectIsOrderInputActive = (state: { isOrderInputActive?: boolean | null }): boolean => state?.isOrderInputActive ?? true;
